/* HealthCo — interacciones de la tienda (guía de tallas, colores, completa el set,
   complementos y "te puede faltar" del carrito). */
(function () {
  'use strict';

  function infoRoot(el) {
    return (el && el.closest('.product__info-container')) || document;
  }

  /* ---------- Ventanas (guía de tallas / foto de colores) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-hc-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-hc-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        var def = dlg.getAttribute('data-hc-default-tab');
        if (def) selectTab(dlg, def);
        dlg.showModal();
        document.documentElement.classList.add('hc-dialog-open');
      }
      return;
    }
    var closer = e.target.closest('[data-hc-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('hc-dialog')) {
      e.target.close(); // clic por fuera
      return;
    }
    var tab = e.target.closest('[data-hc-tab]');
    if (tab) {
      selectTab(tab.closest('dialog') || document, tab.getAttribute('data-hc-tab'));
    }
  });

  document.addEventListener(
    'close',
    function (e) {
      if (e.target.classList && e.target.classList.contains('hc-dialog')) {
        document.documentElement.classList.remove('hc-dialog-open');
      }
    },
    true
  );

  function selectTab(scope, name) {
    scope.querySelectorAll('[data-hc-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-hc-tab') === name ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-hc-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-hc-panel') !== name;
    });
  }

  /* ---------- Ver los 24 colores ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hc-colors-more]');
    if (!btn) return;
    var root = infoRoot(btn);
    var open = !(root.classList && root.classList.contains('hc-colors-open'));
    if (root.classList) root.classList.toggle('hc-colors-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Completa el set ---------- */
  function selectedColor(root) {
    var input = root.querySelector('.hc-opt-color input:checked');
    if (input) return input.value;
    var sel = root.querySelector('.hc-opt-color select');
    return sel ? sel.value : null;
  }

  function pairData(pairRoot) {
    if (!pairRoot._hcData) {
      try {
        pairRoot._hcData = JSON.parse(pairRoot.querySelector('[data-hc-pair-data]').textContent);
      } catch (err) {
        pairRoot._hcData = null;
      }
    }
    return pairRoot._hcData;
  }

  function findPairVariant(pairRoot) {
    var data = pairData(pairRoot);
    if (!data) return null;
    var root = infoRoot(pairRoot);
    var color = selectedColor(root);
    var colorIndex = -1;
    data.options.forEach(function (name, i) {
      if (String(name).toLowerCase().indexOf('color') !== -1) colorIndex = i;
    });
    var sizeInput = pairRoot.querySelector('[data-hc-pair-size]:checked');
    var size = sizeInput ? sizeInput.value : null;
    var norm = function (v) {
      return String(v || '').trim().toLowerCase();
    };
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (colorIndex > -1 && color && norm(v.options[colorIndex]) !== norm(color)) continue;
      if (data.sizeIndex > -1 && size && norm(v.options[data.sizeIndex]) !== norm(size)) continue;
      return v;
    }
    return null;
  }

  function refreshPair(pairRoot) {
    var root = infoRoot(pairRoot);
    var color = selectedColor(root);
    var colorEl = pairRoot.querySelector('[data-hc-pair-color]');
    if (colorEl) colorEl.textContent = color ? ' · ' + color : '';
    var toggle = pairRoot.querySelector('[data-hc-pair-toggle]');
    var error = pairRoot.querySelector('[data-hc-pair-error]');
    if (toggle && toggle.getAttribute('aria-pressed') === 'true') {
      var v = findPairVariant(pairRoot);
      if (v && v.available) {
        pairRoot.setAttribute('data-hc-variant', v.id);
        if (error) error.hidden = true;
      } else {
        toggle.setAttribute('aria-pressed', 'false');
        pairRoot.removeAttribute('data-hc-variant');
        if (error) error.hidden = false;
      }
    }
    updateNote(root);
  }

  function refreshAllPairs() {
    document.querySelectorAll('[data-hc-pair-root]').forEach(refreshPair);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hc-pair-toggle]');
    if (!toggle) return;
    var pairRoot = toggle.closest('[data-hc-pair-root]');
    var error = pairRoot.querySelector('[data-hc-pair-error]');
    if (toggle.getAttribute('aria-pressed') === 'true') {
      toggle.setAttribute('aria-pressed', 'false');
      pairRoot.removeAttribute('data-hc-variant');
    } else {
      var v = findPairVariant(pairRoot);
      if (v && v.available) {
        toggle.setAttribute('aria-pressed', 'true');
        pairRoot.setAttribute('data-hc-variant', v.id);
        if (error) error.hidden = true;
      } else if (error) {
        error.hidden = false;
      }
    }
    updateNote(infoRoot(pairRoot));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-hc-pair-size]')) {
      refreshPair(e.target.closest('[data-hc-pair-root]'));
    }
    if (e.target.closest('variant-selects')) {
      refreshAllPairs();
      // Dawn vuelve a dibujar las opciones un momento después del cambio
      setTimeout(refreshAllPairs, 600);
    }
    if (e.target.matches('[data-hc-addon]')) {
      var row = e.target.closest('[data-hc-addon-row]');
      if (row) row.classList.toggle('is-on', e.target.checked);
      updateNote(infoRoot(e.target));
    }
  });

  /* ---------- Complementos ---------- */
  function collectExtras(root) {
    var items = [];
    root.querySelectorAll('[data-hc-addon-row]').forEach(function (row) {
      var check = row.querySelector('[data-hc-addon]');
      var variant = row.querySelector('[data-hc-addon-variant]');
      if (check && check.checked && variant && variant.value) {
        items.push({ id: Number(variant.value), quantity: 1 });
      }
    });
    root.querySelectorAll('[data-hc-pair-root][data-hc-variant]').forEach(function (pairRoot) {
      var toggle = pairRoot.querySelector('[data-hc-pair-toggle]');
      if (toggle && toggle.getAttribute('aria-pressed') === 'true') {
        items.push({ id: Number(pairRoot.getAttribute('data-hc-variant')), quantity: 1 });
      }
    });
    return items;
  }

  function updateNote(root) {
    var note = root.querySelector && root.querySelector('[data-hc-extras-note]');
    if (!note) return;
    var n = collectExtras(root).length;
    note.hidden = n === 0;
    note.textContent = n === 1 ? 'Se agregará 1 producto más junto con tu uniforme.' : 'Se agregarán ' + n + ' productos más junto con tu uniforme.';
  }

  // Lo usa product-form.js al dar clic en "Agregar al carrito"
  window.hcCollectExtras = function (form) {
    return collectExtras(infoRoot(form));
  };

  document.addEventListener('DOMContentLoaded', refreshAllPairs);
  if (document.readyState !== 'loading') refreshAllPairs();

  /* ---------- Barra fija de compra (celular) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-hc-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var target = document.getElementById(bar.getAttribute('data-target'));
    if (!target) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
        bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        var btn = bar.querySelector('[data-hc-sticky-btn]');
        if (btn) btn.tabIndex = passed ? 0 : -1;
      });
    });
    io.observe(target);
    bar.querySelector('[data-hc-sticky-btn]').addEventListener('click', function () {
      var picker = document.querySelector('variant-selects') || target;
      picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();

  /* ---------- Te puede faltar (carrito) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hc-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.hc-upsell__item');
    var variant = item && item.querySelector('[data-hc-upsell-variant]');
    if (!variant || !variant.value) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    var base = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'error');
        if (drawer && data.sections) {
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Agregar';
      });
  });
})();
